import { Box, InputAdornment, OutlinedInput } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import * as React from "react";

import { styles } from "../../sections/files/filters/metashot-type-filter";

type Props = {
  label?: string;
  name?: string;
  value?: string;
  defaultValue?: string | undefined;
  className?: string | undefined;
  type?: string;
  prefix?: string;
  width?: string;
  placeholder?: string;

  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export default function InputText(props: Props): React.ReactElement {
  const {
    label,
    value,
    width = 100,
    prefix,
    name,
    type = "text",
    placeholder,
    onChange,
  } = props;

  // const [string, setString] = React.useState(value);

  return (
    <Box sx={styles}>
      <FormControl
        className="custom-text-input"
        size="small"
        variant="outlined"
      >
        <InputLabel className="text-[14px]">{label}</InputLabel>
        <OutlinedInput
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            onChange(e);
            // setString(e.target.value);
          }}
          style={{ width: `${width}px` }}
          type={type}
          placeholder={placeholder}
          className="border-0 rounded-[15px] text-[14px]"
          label={label}
          name={name}
          value={value ?? ""}
          startAdornment={
            <InputAdornment position="start">{prefix}</InputAdornment>
          }
        />
      </FormControl>
    </Box>
  );
}
